import axios, { AxiosResponse } from "axios";

import Utils, { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import {
    OrgStructureCreateModel,
    OrgStructureDeleteResult,
    OrgStructureDetailModel,
    OrgStructureEditModel,
} from "@teamprevent/common/orgStructure/models";

class OrgStructureApi {

    private readonly apiUrl = "/api/OrgStructure";

    public async getAll(customerId: string, orgStructureId?: string, name?: string): Promise<OrgStructureDetailModel[]> {
        const response = await axios.get<
            any,
            AxiosResponse<ServerModelWithDateStrings<OrgStructureDetailModel>[]>
        >(`${this.apiUrl}/${customerId}`, { params: { orgStructureId, name } });
        const data = response.data;
        return data.map(this.parseModel);
    }

    public async getAllSearch(customerId: string, search?: string, parentLevel?: string): Promise<OrgStructureDetailModel[]> {
        let query = Utils.getOnlyParameters();
        if (search) {
            query = Utils.AddQueryStringParameter(query, "search", search);
        }
        if (parentLevel) {
            query = Utils.AddQueryStringParameter(query, "orgStructureId", parentLevel);
        }
        const response = await axios.get<
            any,
            AxiosResponse<ServerModelWithDateStrings<OrgStructureDetailModel>[]>
        >(`${this.apiUrl}/${customerId}${query}`);
        const data = response.data;
        return data.map(this.parseModel);
    }

    public async detail(customerId: string, id: string): Promise<OrgStructureDetailModel> {
        const query = Utils.getOnlyParameters();
        const response = await axios.get<
            any,
            ServerModelWithDateStrings<AxiosResponse<OrgStructureDetailModel>>
        >(`${this.apiUrl}/${customerId}/${id}${query}`);
        const model = response.data;
        return this.parseModel(model);
    }

    public async save(customerId: string, orgStructure: OrgStructureEditModel): Promise<OrgStructureDetailModel> {
        const query = Utils.getOnlyParameters();
        const response = await axios.put<
            ServerModelWithDateStrings<OrgStructureDetailModel>,
            ServerModelWithDateStrings<AxiosResponse<OrgStructureDetailModel>>,
            ServerModelWithDateStrings<OrgStructureEditModel>
        >(`${this.apiUrl}/${customerId}${query}`, orgStructure);
        const model = response.data;
        return this.parseModel(model);
    }

    public async create(customerId: string, orgStructure: OrgStructureCreateModel): Promise<OrgStructureDetailModel> {
        const query = Utils.getOnlyParameters();
        const response = await axios.post<
            ServerModelWithDateStrings<OrgStructureCreateModel>,
            ServerModelWithDateStrings<AxiosResponse<OrgStructureDetailModel>>,
            ServerModelWithDateStrings<OrgStructureCreateModel>
        >(`${this.apiUrl}/${customerId}${query}`, orgStructure);
        const model = response.data;
        return this.parseModel(model);
    }

    public async delete(customerId: string, id: any): Promise<OrgStructureDeleteResult> {
        const query = Utils.getOnlyParameters();
        const response = await axios.delete(`${this.apiUrl}/${customerId}/${id}${query}`);
        return response.data;
    }

    public parseModel(model: ServerModelWithDateStrings<OrgStructureDetailModel>): OrgStructureDetailModel {
        return {
            ...model,
            allowanceStartDate: model.allowanceStartDate ? new Date(model.allowanceStartDate) : undefined,
            allowanceEndDate: model.allowanceEndDate ? new Date(model.allowanceEndDate) : undefined,
        };
    }
}

export const orgStructureApi = new OrgStructureApi();
